export function LocationIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="51"
      height="72"
      viewBox="0 0 51 72"
      fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.4729 0.0898438C11.4046 0.0898407 0 11.5767 0 25.7462C-2.11955e-06 38.0139 10.5214 52.3919 20.768 66.3945C21.7385 67.7207 22.7065 69.0435 23.6629 70.3609C24.5494 71.5819 26.3782 71.5696 27.2514 70.339C28.5642 68.489 29.9133 66.6215 31.2698 64.7437C40.9204 51.384 50.9459 37.5055 50.9459 25.7462C50.9459 11.5767 39.5412 0.089845 25.4729 0.0898438ZM25.473 35.7519C30.8993 35.7519 35.2983 31.353 35.2983 25.9267C35.2983 20.5003 30.8993 16.1014 25.473 16.1014C20.0466 16.1014 15.6477 20.5003 15.6477 25.9267C15.6477 31.353 20.0466 35.7519 25.473 35.7519Z"
        fill="url(#paint0_linear_148_6898)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_148_6898"
          x1="42.2123"
          y1="49.4354"
          x2="8.91552"
          y2="8.13286"
          gradientUnits="userSpaceOnUse">
          <stop stop-color="#3CE3D3" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
      </defs>
    </svg>
  )
}
